module.exports = __webpack_public_path__ + "img/perforaciones_16-9_1920.c9b4e555.webp";